import { delimiter } from 'plugin-live-exploratory-viz/src/services/constants'

export function getMultiChannelIdentifier(assetId: string, qualifier: string): string {
    return `${assetId}${delimiter}${qualifier}`
}

export function getChannelIdentifier(multiChannelIdentifier: string): string {
    return multiChannelIdentifier?.split?.(delimiter)?.[1] ?? ''
}

export function getAssetIdentifier(multiChannelIdentifier: string): string {
    return multiChannelIdentifier?.split?.(delimiter)?.[0] ?? ''
}
